import { useDispatch } from 'react-redux';
import { removeProductFromCompare } from '@client/product/redux/productsCompare/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useRemoveProductFromCompareAction = (): typeof removeProductFromCompare => {
  const dispatch = useDispatch();

  return bindActionCreators(removeProductFromCompare, dispatch);
};
